import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'liveRoom',
      type: 'select',
      label: '所属直播间',
      clearable: true,
      placeholder: '请选择直播间'
    },
    {
      field: 'name',
      type: 'input',
      label: '商品名称',
      clearable: true,
      placeholder: '请输入商品名称'
    },
    {
      field: 'isShow',
      type: 'select',
      label: '是否上架',
      clearable: true,
      options: [
        {title: '全部', value: ''},
        {title: '是', value: '1'},
        {title: '否', value: '0'}
      ]
    }
  ]
}
